<ion-list>
  <ion-item *ngFor="let item of responsibilityItems">
    <ion-checkbox [(ngModel)]="item.checked">{{ item.label }}</ion-checkbox>
  </ion-item>
</ion-list>
